<template>
  <div class="full-width">
    <AppEditForm
      padding
      class="row q-px-md q-mb-xl"
      @save="save"
      :edit="edit"
      :new="isNew"
    >
      <div class="gt-xl col-xl-2" />
      <div class="col-12 col-sm-9 col-xl-6 q-mt-md row">

        <div class="col-12 col-sm-6 q-px-sm">
          <AppInput v-if="!isNew"
                    label="Código"
                    autogrow
                    type="textarea"
                    v-model="puil.numero"
          />
        </div>
        <div class="col-sm-4 col-12  q-px-sm">
        </div>

        <div class="col-8 q-px-sm">
          <AppSelect
              label="Situação *"
              v-model="situacao"
              @filter="situacaoFilter"
              :options="situacoes"
              editable
          />
        </div>
        <div class="col-sm-4 col-12  q-px-sm">
          <AppDateSelect label="Data da Situação *" v-model="puil.dataSituacao" editable required/>
        </div>

        <div class="col-12 col-sm-12 q-px-sm">
          <AppSelect
            label="Ramo do Direito"
            v-model="ramo"
            v-if="ramo || edit || userStore.admin"
            @filter="ramoFilter"
            :options="ramos"
            autofocus
            editable
          />
        </div>

        <div class="col-12 q-px-sm">
          <AppSelect
            label="Assuntos *"
            v-model="assunto"
            @filter="assuntoFilter"
            :options="assuntos"
            use-input
            multiple
            editable
          />
        </div>
        <div class="col-12 q-px-sm">
          <AppInput
            label="Questão submetida a julgamento *"
            autogrow
            type="textarea"
            v-model="puil.questao"
            v-if="puil.questao || edit || userStore.admin"
            editable
            required
            maxlength="4000"
            showCounter
          />
        </div>
        <div class="col-12 q-px-sm">
          <AppInput label="Tese jurídica fixada"
                    v-model="puil.tese"
                    v-if="puil.tese || edit || userStore.admin"
                    type="textarea"
                    autogrow
                    editable
                    maxlength="4000"
                    showCounter
          />
        </div>
        <div class="col-12 q-px-sm">
          <AppInput
            label="Referência Legislativa"
            autogrow
            v-model="puil.referenciaLegislativa"
            v-if="puil.referenciaLegislativa || edit || userStore.admin"
            editable
            maxlength="4000"
            showCounter
          />
        </div>

        <div class="col-12 q-px-sm">
          <AppInput
              label="Texto Decisão Admissão"
              autogrow
              type="textarea"
              v-model="puil.textoDecisaoAdmissao"
              v-if="puil.textoDecisaoAdmissao || edit || userStore.admin"
              editable
              maxlength="4000"
              showCounter
          />
        </div>

        <div class="col-12 q-px-sm">
          <AppInput
              label="Texto Ementa Admissão"
              autogrow
              type="textarea"
              v-model="puil.textoEmentaAdmissao"
              v-if="puil.textoEmentaAdmissao || edit || userStore.admin"
              editable
              maxlength="4000"
              showCounter
          />
        </div>

        <div class="col-12 q-px-sm">
          <AppInput
              label="Relator"
              v-model="puil.relator"
              v-if="puil.relator"
              maxlength="255"
              showCounter
          />
        </div>

        <div class="col-12 q-px-sm">
          <AppInput
              label="Texto Acórdão Admissão"
              autogrow
              type="textarea"
              v-model="puil.textoAcordaoAdmissao"
              v-if="puil.textoAcordaoAdmissao || edit || userStore.admin"
              editable
              maxlength="4000"
              showCounter
          />
        </div>

        <div class="col-12 q-px-sm">
          <AppInput
              label="Texto Ementa Mérito"
              autogrow
              type="textarea"
              v-model="puil.textoEmentaMerito"
              v-if="puil.textoEmentaMerito || edit || userStore.admin"
              editable
              maxlength="4000"
              showCounter
          />
        </div>

        <div class="col-12 q-px-sm">
          <AppInput
              label="Texto Acórdão Mérito"
              autogrow
              type="textarea"
              v-model="puil.textoAcordaoMerito"
              v-if="puil.textoAcordaoMerito || edit || userStore.admin"
              editable
              maxlength="4000"
              showCounter
          />
        </div>

        <div class="col-12 q-px-sm">
          <AppInput
              label="Texto Decisão Suspensão"
              autogrow
              type="textarea"
              v-model="puil.textoDecisaoSuspensao"
              v-if="puil.textoDecisaoSuspensao || edit || userStore.admin"
              editable
              maxlength="4000"
              showCounter
          />
        </div>

        <div class="col-sm-4 col-12  q-px-sm">
          <AppSelect
              label="Alcance do Sobrestamento"
              v-model="parametro"
              v-if="parametro || edit || userStore.admin"
              @filter="parametroFilter"
              :options="parametros"
              editable/>
        </div>

        <div class="col-sm-6 col-12  q-px-sm">
          <AppDateSelect label="Data da Decisão do Alcance do Sobrestamento *" v-if="parametro" v-model="puil.dataSuspensao" required editable/>
        </div>

          <div class="col-12 q-px-sm">
            <AppInput
                label="Detalhe Abrangência Específica *"
                v-model="puil.detalheAbrangenciaEspecifica"
                v-if="parametro && (puil.detalheAbrangenciaEspecifica || edit || userStore.admin)"
                editable
                autogrow
                required
                maxlength="1000"
                showCounter
            />
          </div>

        <div class="col-12 q-px-sm">
          <AppInput
              label="Link Decisão *"
              v-model="puil.linkDecisao"
              v-if="parametro && (puil.linkDecisao || edit || userStore.admin)"
              editable
              required
              autogrow
              maxlength="1000"
              showCounter
          />
        </div>

        <div class="col-sm-7 col-12  q-px-sm q-mb-md">
          <AppDateSelect label="Data final da determinação de suspensão de processos" v-if="parametro" v-model="puil.dataFimSuspensao" editable/>
        </div>

        <div class="col-sm-6 col-12  q-px-sm q-mb-md">
          <AppInput label="Número Tema Sobrestado" v-model="puil.numeroTemaSobrestado"
                    v-if="puil.numeroTemaSobrestado || edit || userStore.admin"
                    editable
                    mask="####"
          />
        </div>

        <div class="col-12 q-px-sm">
          <AppInput
              label="Anotações NUGEPNAC"
              autogrow
              type="textarea"
              v-model="puil.anotacoesNugep"
              v-if="puil.anotacoesNugep || edit || userStore.admin"
              editable
          />
        </div>
        <div class="col-12 q-px-sm text-right">
          <q-chip v-if="puil.statusEnvioBnp && userStore.admin" outline square color="green" text-color="white" icon="done">
            Enviado ao BNP
          </q-chip>
          <q-chip v-if="!puil.statusEnvioBnp && userStore.admin" outline square color="red" text-color="white" icon="close">
            Não enviado ao BNP
          </q-chip>
        </div>
      </div>
      <AppTimeline
        class="col-12 col-sm-3 col-xl-2"
        v-model="timeline"
        :edit="edit || isNew"
        :requires=0
      />

      <div class="gt-xl col-xl-2" />
      <div class="gt-xl col-xl-2" />
      <div class="col-xl-8 col-sm-12">
        <div class="col-12 q-px-sm">
          <q-chip outline color="primary" text-color="white">
            Processo *
          </q-chip>
        </div>
        <AppInfiniteListForm v-model="processosparadigma">
          <template v-slot:item="data">
            <MiniProcessoParadigma v-bind="data" />
          </template>
          <ProcessoParadigma/>
        </AppInfiniteListForm>
        <div class="q-my-md">
        </div>
      </div>

      <q-page-sticky
        position="bottom-right"
        :offset="[18, 18]"
        v-if="userStore.admin"
      >
        <AppSaveBtn v-if="edit" :disable="disableButton"/>
        <AppDeleteBtn v-if="!isNew" @click="showConfirmDeletion" :disable="disableButton"/>
        <AppEditBtn v-if="!isNew" @click="toggleEditMode" />
      </q-page-sticky>
    </AppEditForm>
    <TjpaDemandasDeleteModal
      :show="showConfirmDeletionModal"
      @update:show="showConfirmDeletionModal = $event"
      @confirmDeletion="confirmDeletion"
      :id="$route.params.id"
    />
  </div>
</template>


<script setup>
import MiniProcessoParadigma from "@/components/app/AppMiniProcessoPje.vue";
MiniProcessoParadigma;
import AppInfiniteListForm from "@/components/app/AppInfiniteListForm.vue";
AppInfiniteListForm;
import ProcessoParadigma from "@/components/app/AppProcessoPje.vue";
import AppEditForm from "../app/AppEditForm.vue";
import AppDeleteBtn from "../app/AppDeleteBtn.vue";
import AppEditBtn from "../app/AppEditBtn.vue";
import AppSaveBtn from "../app/AppSaveBtn.vue";
import AppInput from "../app/AppInput.vue";
import AppSelect from "../app/AppSelect.vue";
import AppDateSelect from "../app/AppDateSelect.vue";
import AppTimeline from "@/components/app/AppTimeline.vue";
AppTimeline;
import TjpaDemandasDeleteModal from "../tjpa-demandas-delete-modal.vue";

import { useProcessoParadigmaStore } from "@/store/processoparadigma-store";

import { usePuilSituacaoStore } from "@/store/puil-situacao-store";
import { useParametroLimiteSuspensaoStore } from "@/store/parametro-store";
import { useTemaAssuntoStore } from "@/store/tema-assunto-store";
import { useTemaRamoStore } from "@/store/tema-ramo-store";

import { usePuilStore } from "@/store/puil-store";
import { useUserStore } from "@/store/user-store";

import {ref, computed, defineProps} from "vue";
import { useQuasar } from "quasar";
import { useRouter, useRoute } from "vue-router";

const quasar = useQuasar();
const router = useRouter();
const route = useRoute();

const userStore = useUserStore();
const ramoStore = useTemaRamoStore();
ramoStore.fetch();
const situacaoStore = usePuilSituacaoStore();
situacaoStore.fetch();
const parametroStore = useParametroLimiteSuspensaoStore();
parametroStore.fetch();
const assuntoStore = useTemaAssuntoStore();
assuntoStore.fetch();

const notify = (...p) => quasar.notify(...p);

const puilStore = usePuilStore();

import {
  filterFunction,
  baseUrlDelete,
  DELETE_FAILURE,
  DELETE_SUCCESS, CREATE_SUCCESS, ALTER_SUCCESS
} from "@/DemandasRepetitivas";

const procStore = useProcessoParadigmaStore();

const props = defineProps({ id: { type: String } });
props.id && puilStore.fetchStg(props.id);

const _edit = ref(false);

const processosparadigma = computed({
  get: () => edit.value ? procStore.processos: puil.value.processosParadigma,
  set: v => (procStore.processos = v)
});

const puil = computed(() => puilStore.stgTema);

const sourcePuil = computed(
  () => props.id && puilStore.all.find(t => t.id == props.id)
);

const isNew = computed(() => !props.id);
const showConfirmDeletionModal = ref(false);
const disableButton = ref(false);

const admin = computed(() => userStore.admin)
const situacoes = computed(() => situacaoStore.filtered);
const parametros = computed(() => parametroStore.filtered);
const assuntos = computed(() => assuntoStore.filtered);
const ramos = computed(() => ramoStore.filtered);

const ramo = computed({
  get: () => ramoStore.all?.find(e => e.codigo == puil.value.idRamoDireito),
  set: v => (puil.value.idRamoDireito = v.codigo)
});
const situacao = computed({
  get: () => (situacaoStore.all?.find(s => s.id == puil.value.idSituacaoPuil)),
  set: v => (puil.value.idSituacaoPuil = v ? v.id : null)
});
const parametro = computed({
  get: () => (parametroStore.all?.find(s => s.id == puil.value.parametro)),
  set: v => (puil.value.parametro = v ? v.id : null)
});
const assunto = computed({
  get: () => puil.value?.assuntoTema?.map(a => assuntoStore.assuntoAllList?.find(e => e.codigo == a.codigo)),
  set: v => puil.value.assuntoTema = v
});

const edit = computed({get:() => (_edit.value && admin.value),set:v=>(_edit.value = v)})

const toggleEditMode = () => {
  edit.value = !edit.value ;
  if(edit.value == true){
    procStore.processos = puil.value.processosParadigma;
  }
  if (edit.value == false && puil.value.equals(sourcePuil.value) == false) {
    notify({
      message: "Existem Alterações não salvas",
      color: "warning"
    });
  }
};

if (isNew.value) {
  puilStore.clearStg();
  procStore.clear();
  edit.value = false;
  toggleEditMode();
}

const timeline = computed({
  get: () => {
    const { dataAdmissao, dataJulgamento, dataPublicacao, dataTransitoJulgado } = puil.value;
    return [
      { order: 1, name: "Admissão *", date: dataAdmissao, icon: "launch" },
      { order: 2, name: "Julgamento", date: dataJulgamento, icon: "gavel" },
      { order: 3, name: "Publicação", date: dataPublicacao, icon: "publish" },
      { order: 4, name: "Trânsito", date: dataTransitoJulgado, icon: "done_all" }
    ];
  },
  set: v => {
    let timelineFields = ["Admissao", "Julgamento", "Publicacao", "TransitoJulgado"];
    timelineFields = timelineFields.map(
      fieldName => (fieldName = `data${fieldName}`)
    );
    timelineFields.forEach(
      (fieldName, i) => (puil.value[fieldName] = v[i].date)
    );
  }
});

const ramoFilter = (val, update) =>
  filterFunction(...[ramos.value, ramoStore.all, val, update]);
const situacaoFilter = (val, update) =>
  filterFunction(...[situacoes.value, situacaoStore.all, val, update]);
const parametroFilter = (val, update) =>
    filterFunction(...[parametros.value, parametroStore.all, val, update]);
const assuntoFilter = (v, up) =>
  filterFunction(...[assuntos.value, assuntoStore.assuntoAllList, v, up]);

const save = async () => {

  if (!situacao.value) {
    notify({
      message: "É obrigatória a escolha de uma situação.",
      color: "warning"
    });
    return;
  }

  if (assunto.value.length == 0) {
    notify({
      message: "É obrigatória a escolha de pelo menos um assunto.",
      color: "warning"
    });
    return;
  }

  if (procStore.processos.length > 1) {
    notify({
      message: "Não é possível o vínculo de mais de 1 processo.",
      color: "warning"
    });
    return;
  }

  if (procStore.processos.length == 0) {
    notify({
      message: "É obrigatório o vinculo de 1 processo ao PUIL.",
      color: "warning"
    });
    return;
  }

  disableButton.value = true;

  let success_msg = isNew.value ? CREATE_SUCCESS : ALTER_SUCCESS;
  const reload = () => puilStore.clearStg();
  const failure = msg =>
    notify({
      message: msg,
      color: "negative"
    });
  const success = (id) =>
    notify({
      message: `O Puil ${id} ` + success_msg,
      color: "positive"
    });

  const successAndReload = id => {
    success(id);
    router.push("/puilhome");
    if(isNew.value){
      reload();
    }
  };
  try {
    const readResponse = await puilStore.saveStg();
    successAndReload(readResponse.data);
    //failure(id);
  } catch (e) {
    disableButton.value = false;
    if(e.response.status == 401){
      failure("Sessão Expirou.");
      router.push("/");
      reload();
    }else{
      failure(e.response.data.message);
    }
  }
};

const goHome = () => router.push("/puilhome");

const showConfirmDeletion = () => (showConfirmDeletionModal.value = true);

const confirmDeletion = () => {
  disableButton.value = true;
  const reload = () => goHome();

  const notifyObj = (message, color) => ({ message, color });
  const failure = () => notify(notifyObj(DELETE_FAILURE, "negative"));
  const success = () => notify(notifyObj(DELETE_SUCCESS, "positive"));

  const successAndReload = () => {
    success();
    reload();
  };
  const httpOk = r => r.status == 200;
  const readResponse = r => (httpOk(r) ? successAndReload() : failure());

  baseUrlDelete(`pedido-uniformizacao/${route.params.id}`)
    .then(readResponse)
    .catch(failure);
};
</script>

<style lang="scss" >
@import "@/styles/quasar.variables.sass";

.tjpa-select-input {
  max-height: 30vh !important;
}

.AppSelect__dialog {
  margin-top: 90px;
}
</style>
